export default "__VITE_ASSET__01b8ec3c__"